/**
 * The territory screen's route literal: `./routes.ts` registers it and a
 * caller that links here imports the helper rather than spelling a second
 * literal. Relative to the router's `basepath`, like every other route in the
 * app.
 */

import { interpolatePath } from '@tanstack/react-router';

export const TERRITORY_PATH = '/c/$campaignId/territory';

export function territoryPath(campaignId: string): string {
  return interpolatePath({ path: TERRITORY_PATH, params: { campaignId } }).interpolatedPath;
}
